import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';

const AnalyticsDashboard = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initialize GA and track pageview
  useEffect(() => {
    ReactGA.initialize('G-M2E1MP9L8C');
    ReactGA.send('pageview');
  }, []);

  // Fetch analytics data from your backend API
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await fetch('/api/analytics');
        const data = await response.json();
        setAnalyticsData(data);
      } catch (error) {
        console.error('Error fetching analytics:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Analytics Dashboard</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Active Users Card */}
        <div className="bg-white p-6 rounded-lg ">
          <h3 className="text-lg font-semibold text-gray-700">Active Users</h3>
          <p className="text-3xl font-bold text-blue-600 mt-2">
            {analyticsData?.activeUsers || 'N/A'}
          </p>
        </div>

        {/* Page Views Card */}
        <div className="bg-white p-6 rounded-lg ">
          <h3 className="text-lg font-semibold text-gray-700">Page Views</h3>
          <p className="text-3xl font-bold text-green-600 mt-2">
            {analyticsData?.pageViews || 'N/A'}
          </p>
        </div>

        {/* Bounce Rate Card */}
        <div className="bg-white p-6 rounded-lg ">
          <h3 className="text-lg font-semibold text-gray-700">Bounce Rate</h3>
          <p className="text-3xl font-bold text-purple-600 mt-2">
            {analyticsData?.bounceRate ? `${analyticsData.bounceRate}%` : 'N/A'}
          </p>
        </div>
      </div>

      {/* Add more analytics widgets as needed */}
    </div>
  );
};

export default AnalyticsDashboard;